import { html, LitElement, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../ui-inlined-svg/ui-inlined-svg';
import iconStyle from './ui-settings-icon.css?inline';

const CName = 'ui-settings-icon';

@customElement(CName)
export class UISettingsIcon extends LitElement {
  static readonly styles = unsafeCSS(iconStyle);

  render() {
    const assetUrl = new URL('/assets/ui-core/icons/settings-icon.svg', import.meta.url).href;
    return html`<ui-inlined-svg .css=${UISettingsIcon.styles} .defer=${true} .src=${assetUrl}></ui-inlined-svg>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UISettingsIcon;
  }
}
